import { Observable, finalize, merge, take, tap } from 'rxjs';

import {
  TCompanyConfigs,
  companyConfigService,
} from '../../../../shared/services/companyConfig/companyConfig.service.ts';
import { Pub, State, Sub } from '../../../../shared/state/state.abstract.ts';

class PubImpl extends Pub<IPrintFormsTabState> {
  recordData(dataToSave: IPrintFormsTabState['dataToSave']) {
    this.emit('recordData', { dataToSave });
  }
  saveData() {
    this.emit('saveData', {});
  }
  clearStream() {
    this.emit(undefined, {});
  }
}
class SubImpl extends Sub<IPrintFormsTabState> {
  protected actionHandlers(): Observable<IPrintFormsTabState> {
    return merge(this.saveData());
  }

  private saveData(): Observable<IPrintFormsTabState> {
    return this.actionListener('saveData').pipe(
      tap(({ dataToSave }) => {
        companyConfigService.saveConfigData(dataToSave).pipe(take(1)).subscribe();
      }),
      finalize(() => printFormsTabState.pub.clearStream()),
    );
  }
}

class PrintFormsTabState extends State<IPrintFormsTabState> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const printFormsTabState = new PrintFormsTabState({
  action: undefined,
  dataToSave: {},
});

export interface IPrintFormsTabState {
  action: undefined | 'recordData' | 'saveData';
  dataToSave: TCompanyConfigs | object;
}
